export default "__VITE_ASSET__07cf495e__"